/**
 * ACCourseSettingService
 * Service for managing Courses module settings (key/value)
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for module setting operations (getAll + update)
 */
export class ACCourseSettingService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? ACCourseSettingService.DEFAULT_SERVICE_PATH,
            basePath: ACCourseSettingService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
ACCourseSettingService.DEFAULT_SERVICE_PATH = 'ac-courses';
ACCourseSettingService.BASE_PATH = 'api/course-settings';
//# sourceMappingURL=ACCourseSettingService.js.map